<div
  class="document-status"
  [class]="DocumentStatusEnum[status ?? DocumentStatusEnum.Draft]"
>
  {{ documentStatusLabels[status ?? DocumentStatusEnum.Draft] }}
</div>
